<div class="saved-view-side-pane-item" (click)="onLoadClicked()">
  <div class="saved-view-side-pane-item__left">
    <div class="kxi-text-normal saved-view-side-pane-item__name" [matTooltip]="item?.name">
      <ng-container *appMiddleEllipsize="item?.name"></ng-container>
    </div>
  </div>

  <div class="saved-view-side-pane-item__right">
    <span
      class="saved-view-side-pane-item__menu-trigger"
      [matMenuTriggerFor]="savedViewMenuTrigger"
      (click)="$event.stopPropagation()"
    >
      <xi-icon-button icon="kabob"></xi-icon-button>
    </span>
  </div>
</div>

<mat-menu #savedViewMenuTrigger="matMenu" class="menu-with-xi-icons">
  <ng-template matMenuContent *transloco="let t; read: 'saved-view-side-pane-item-component'">
    <button mat-menu-item (click)="onMenuAction('rename')">
      <div>{{ t('rename') }}</div>
    </button>
    @if (item?.isActive) {
      <button mat-menu-item (click)="onMenuAction('close')">
        <div>{{ t('close') }}</div>
      </button>
    }
    <button mat-menu-item (click)="onMenuAction('delete')">
      <div>{{ t('delete') }}</div>
    </button>
  </ng-template>
</mat-menu>
